module.exports = __webpack_public_path__ + "media/images/png/light-42f4674618476bf2be7d945592dbdb5a.png";